export const cardVerificationURLs = {
  send: (userId: number) => `/v1/users/${userId}/card-verification`
};
